module.exports = __webpack_public_path__ + "img/IMG_2339.90594a72.jpg";